<template>
  <div class="comp-ly-list-universal-buttons">
    <jw-space>
      <template v-for="(b, i) in buttonUniversal" :key="i">
        <!-- 新建飞书合同 -->
        <jw-button class="text-button" @click="toFSApp" size="small" type="outline" v-permission="[`${oem[entity]}:addFSContract`]" v-if="b == `${oem[entity]}:addFSContract`">
          <template #icon v-if="buttonIcons?.[`${oem[entity]}:addFSContract`] && (buttonType?.[`${oem[entity]}:addFSContract`] == 0 || buttonType?.[`${oem[entity]}:addFSContract`] == 1)">
            <component :is="buttonIcons?.[`${oem[entity]}:addFSContract`]" />
          </template>
          <template v-if="buttonType?.[`${oem[entity]}:addFSContract`] == 0 || buttonType?.[`${oem[entity]}:addFSContract`] == 2">
            <span class="universal-text"> {{ buttonTexts?.[`${oem[entity]}:addFSContract`] }}</span>
          </template>
        </jw-button>
        <!-- 新建：add -->
        <jw-button class="add-primary-button" size="small" type="primary" @click="addRow" v-permission="[`${oem[entity]}:add`]" v-if="b == `${oem[entity]}:add`">
          <template #icon v-if="buttonIcons?.[`${oem[entity]}:add`] && (buttonType?.[`${oem[entity]}:add`] == 0 || buttonType?.[`${oem[entity]}:add`] == 1)">
            <component :is="buttonIcons?.[`${oem[entity]}:add`]" />
          </template>
          <template v-if="buttonType?.[`${oem[entity]}:add`] == 0 || buttonType?.[`${oem[entity]}:add`] == 2">
            <span class="universal-text">{{ buttonTexts?.[`${oem[entity]}:add`] }}</span>
          </template>
        </jw-button>
        <!-- 导出：export -->
        <jw-button size="small" type="outline" class="text-button" @click="batchImport" v-permission="[`${oem[entity]}:export`]" v-if="b == `${oem[entity]}:export`" :loading="data.exportLoading">
          <template #icon v-if="buttonIcons?.[`${oem[entity]}:export`] && (buttonType?.[`${oem[entity]}:export`] == 0 || buttonType?.[`${oem[entity]}:export`] == 1)">
            <component :is="buttonIcons?.[`${oem[entity]}:export`]" />
          </template>
          <template v-if="buttonType?.[`${oem[entity]}:export`] == 0 || buttonType?.[`${oem[entity]}:export`] == 2">
            <span class="universal-text"> {{ buttonTexts?.[`${oem[entity]}:export`] }}</span>
          </template>
        </jw-button>
        <!-- 导入：import -->
        <jw-button size="small" type="outline" class="text-button" v-permission="[`${oem[entity]}:import`]" v-if="b == `${oem[entity]}:import`" @click="publicLeadIn()">
          <template #icon v-if="buttonIcons?.[`${oem[entity]}:import`] && (buttonType?.[`${oem[entity]}:import`] == 0 || buttonType?.[`${oem[entity]}:import`] == 1)">
            <component :is="buttonIcons?.[`${oem[entity]}:import`]" />
          </template>
          <template v-if="buttonType?.[`${oem[entity]}:import`] == 0 || buttonType?.[`${oem[entity]}:import`] == 2">
            <span class="universal-text"> {{ buttonTexts?.[`${oem[entity]}:import`] }}</span>
          </template>
        </jw-button>
        <!-- 查重：duplicate -->
        <xl-repeat-button :key="`${oem[entity]}:duplicate`" :showType="buttonType?.[`${oem[entity]}:duplicate`]" :icon="buttonIcons?.[`${oem[entity]}:duplicate`]" :text="buttonTexts?.[`${oem[entity]}:duplicate`]" repeat="1" v-if="b == `${oem[entity]}:duplicate` && userInfo?.roles?.indexOf(`${oem[entity]}:duplicate`) > -1"></xl-repeat-button>
      </template>
      <!-- Bing数据同步 -->
      <jw-button class="text-button" size="small" type="outline" @click="syncBingData" v-if="b == `${oem[entity]}:bingDataSync` && userInfo?.roles?.indexOf(`${oem[entity]}:bingDataSync`) > -1" :loading="data.bingDataLoading">
        <template #icon v-if="buttonIcons?.[`${oem[entity]}:bingDataSync`] && (buttonType?.[`${oem[entity]}:bingDataSync`] == 0 || buttonType?.[`${oem[entity]}:bingDataSync`] == 1)">
          <component :is="buttonIcons?.[`${oem[entity]}:bingDataSync`]" />
        </template>
        <template v-if="buttonType?.[`${oem[entity]}:bingDataSync`] == 0 || buttonType?.[`${oem[entity]}:bingDataSync`] == 2">
          <span class="universal-text"> {{ buttonTexts?.[`${oem[entity]}:bingDataSync`] }}</span>
        </template>
      </jw-button>
    </jw-space>
  </div>
  <!--导入  -->
  <xl-export ref="exportRef" @cb="refreshList"></xl-export>
  <!-- 新导入并修改数据 S-->
  <xl-import-edit ref="importEditRef" @cb="refreshList"></xl-import-edit>
  <!-- Bing数据同步 -->
  <bing-data-sync ref="bingSyncRef" @cb="bingCallBack"></bing-data-sync>
</template>

<script setup>
import { reactive, ref, computed, watch, onBeforeUnmount } from 'vue';
import { objEntityMapping, MAX_EXPORT_COUNT } from '@/utils/const';
import { Message, Modal } from '@arco-design/web-vue';
import useOperation from '@/hooks/operation.js';
import { useUserStore } from '@/store';
import { tools } from '@/utils/tools';
import { useI18n } from 'vue-i18n';
const { userInfo } = useUserStore();
const { t } = useI18n();
const data = reactive({
  bingDataLoading: false,
  exportLoading: false
});
const props = defineProps({
  entityId: {
    type: Number || String,
    default: null
  },
  universalButtonParams: {
    type: Object,
    default: () => {}
  },
  totalCount: {
    type: Number,
    default: 0
  }
});
const oem = ref(JSON.parse(JSON.stringify(objEntityMapping)));
const fp = computed(() => props.universalButtonParams);
const emits = defineEmits(['cb', 'cbAdd']);
console.log(11398, props, oem.value);
const entity = computed(() => props.entityId);
const { listDownload } = useOperation();
// const exportRef = ref(); //导入公共组件
const importEditRef = ref();
const bingSyncRef = ref(); //bing数据同步
/********************回传的按钮******************************* */
// const buttonShortcut = ref([]);
const buttonUniversal = ref([]);
const buttonIcons = ref({});
const buttonTexts = ref({});
const buttonType = ref({});
const getBtnPermissionObj = (btnPermission) => {
  buttonUniversal.value = [];
  console.log(114, btnPermission);
  if (btnPermission?.length) {
    buttonUniversal.value = btnPermission?.length ? Array.from(new Set(btnPermission.map((item) => item.value))) : [];
    console.log(113114, buttonUniversal.value);
  }
  //获取按钮的icon
  buttonIcons.value = tools.getIconsByEntity(userInfo?.menus?.entityResources, entity.value);
  buttonTexts.value = tools.getOptTextsByEntity(userInfo?.menus?.entityResources, entity.value);
  buttonType.value = tools.getShowTypeByEntity(userInfo?.menus?.entityResources, entity.value);
};
/**********************回传的按钮***************************** */
const toFSApp = () => {
  //!isFeiShuApp ? 'https://contract.feishu.cn/' :
  window.open('https://applink.feishu.cn/client/web_app/open?appId=cli_9f4687e5517c900d&mode=window', '_blank');
};
// 新增数据
const addRow = () => {
  const params = { type: 30, viewId: fp.value.viewId, entity: entity.value };
  console.log(126, params);
  emits('cbAdd', params);
};
// 公共批量导出
const batchImport = async () => {
  if (userInfo.platform != 2) {
    Message.error('您不是飞书成员，不能导出');
    return;
  }
  // 校验最大导出条数
  if (props.totalCount > MAX_EXPORT_COUNT) {
    Message.error(`单次数据导出上限为${MAX_EXPORT_COUNT}条，请调整筛选条件后再次尝试`);
    return;
  }

  data.exportLoading = true;
  const params = { page: fp.value.pagination?.current || 1, pageSize: fp.value.pagination?.pageSize || 300, scope: fp.value.filterParams?.scope, conditions: fp.value.filterParams?.conditions || [], id: fp.value.viewId, entity: entity.value, searchConditions: fp.value.filterParams?.searchConditions, sceneId: fp.value?.filterParams?.sceneId };
  await listDownload(params);
  data.exportLoading = false;
};
// 刷新
const refreshList = (params) => {
  emits('cb', params);
};
// 公共导入方法
const publicLeadIn = () => {
  const params = {
    entity: entity.value //1线索2客户3商机4产品
  };
  if (userInfo.platform != 2) {
    Modal.open({
      titleAlign: 'start',
      width: 400,
      simple: false,
      title: t('导入'),
      content: '您不是飞书成员，继续操作导入的话无法收到结果消息通知，是否继续？',
      okText: t('继续'),
      cancelText: t('取消'),
      onOk: () => {
        // exportRef.value.open(params);
        importEditRef.value.open(params);
      }
    });
  } else {
    // exportRef.value.open(params);
    importEditRef.value.open(params);
  }
};
// Bing数据同步
const syncBingData = () => {
  const params = {
    type: entity.value, //客户
    title: entity.value == 10 ? '充值数据同步' : undefined
  };
  bingSyncRef.value.open(params);
};
//bing弹窗的loading状态回调
const bingCallBack = (type, value) => {
  console.log(261, type, value);
  if (type == 2) {
    data.bingDataLoading = value;
    if (!value) {
      refreshList();
    }
  }
};
const stopWatch = watch(
  () => entity.value,
  (v) => {
    if (v >= 200) {
      oem.value[v] = v;
    }
  },
  {
    immediate: true
  }
);
onBeforeUnmount(() => {
  stopWatch();
});
// 抛出方法
defineExpose({ getBtnPermissionObj });
</script>
<style scoped lang="less">
@import './ly-list-universal-buttons.less';
</style>
